import request from './common/request'
import qs from 'qs'
import axios from 'axios'
import store from '@/store'

import { MERCHANT_COMMON_CACHEDATA_URI, MERCHANT_COMMON_MINIAPP_URI, MERCHANT_COMMON_MANAGER_MINIAPP_URI } from './urls'

// 哈希缓存 - 保存
async function saveCacheData(data) {
  return request({
    url: `${MERCHANT_COMMON_CACHEDATA_URI}`,
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 哈希缓存 - 获取
async function getCacheData(params) {
  return request({
    url: `${MERCHANT_COMMON_CACHEDATA_URI}/read`,
    method: 'GET',
    params
  })
}

// 小程序码生成
async function generateMiniappCode(params) {
  const result = await axios.get(`${process.env.BASE_API}${MERCHANT_COMMON_MINIAPP_URI}/generateMiniappCode`, {
    params,
    responseType: 'arraybuffer',
    headers: {
      Authorization: `Bearer ${store.state.MerchantAuth.accessToken}`
    }
  })
  return result
}

// 小程序链接生成
async function generateMiniappURLLink(params) {
  return request({
    url: `${MERCHANT_COMMON_MINIAPP_URI}/generateMiniappURLLink`,
    method: 'GET',
    params
  })
}

// 商户端小程序码生成
async function generateManagerMiniappCode(params) {
  const result = await axios.get(`${process.env.BASE_API}${MERCHANT_COMMON_MANAGER_MINIAPP_URI}/generateMiniappCode`, {
    params,
    responseType: 'arraybuffer',
    headers: {
      Authorization: `Bearer ${store.state.MerchantAuth.accessToken}`
    }
  })
  return result
}

// 商户端小程序链接生成
async function generateManagerMiniappURLLink(params) {
  return request({
    url: `${MERCHANT_COMMON_MANAGER_MINIAPP_URI}/generateMiniappURLLink`,
    method: 'GET',
    params
  })
}

export default {
  saveCacheData,
  getCacheData,
  generateMiniappCode,
  generateManagerMiniappCode,
  generateMiniappURLLink,
  generateManagerMiniappURLLink
}



// WEBPACK FOOTER //
// ./src/api/merchant-common.js